import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../api'

const initialState = {
  cards: [],
  inProgressTotals: {},
  inProgressTable: [],
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      graphqlApi.endpoints.getDashboardData.matchFulfilled,
      (state, { payload }) => {
        return payload
      }
    )
    builder.addMatcher(
      graphqlApi.endpoints.getDashboardData.matchRejected,
      (state, payload) => {
      }
    )
  }
});

// export const { setStudentData } = dashboardSlice.actions;
export const selectDashboardData = (state) => state.dashboardSlice

export default dashboardSlice.reducer;